<template lang="pug">
  .banner-container(ref="container" :class="[spacingTop, spacingBottom]" :style="{ height: `${height}px` }")
    .image(v-if="image")
      img(
        v-lazy="image"
        :style="{ height: `${height}px` }"
        :title="title || subTitle"
        rel="noopener"
      )
</template>

<script>
import { get, trim, debounce } from '@/helpers';

export default {
  name: 'Banner',
  data() {
    return {
      width: undefined
    };
  },
  props: {
    section: {
      type: Object,
      required: true
    }
  },
  computed: {
    content() {
      return get(this.section, 'contents.0');
    },
    title() {
      return get(this.content, 'title');
    },
    subTitle() {
      return get(this.content, 'sub_title');
    },
    settings() {
      return get(this.section, 'settings') || [];
    },

    spacingTop() {
      let spacingTop = 'spacingTopStandard';

      if (this.section.settings && this.section.settings.length) {
        const setting = this.section.settings.find(setting => setting.key === 'spacingTop');
        if (setting && setting.value !== undefined) spacingTop = setting.value;
      }
      return spacingTop;
    },

    spacingBottom() {
      let spacingBottom = 'spacingBottomStandard';

      if (this.section.settings && this.section.settings.length) {
        const setting = this.section.settings.find(setting => setting.key === 'spacingBottom');
        if (setting && setting.value !== undefined) spacingBottom = setting.value;
      }
      return spacingBottom;
    },

    height() {
      let fr = 160;
      let height = 3 * fr;

      const config = this.settings.find(setting => setting.key === 'height');
      if (config && config.value) {
        switch (config.value) {
          case 'small':
            height = 1 * fr;
            break;

          case 'large':
            height = 3 * fr;
            break;
        }
      }

      return height;
    },
    image() {
      const image = get(this.content, 'images.0');
      if (!image || !this.width) return false;

      const storageRoute = trim(
        `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`,
        '/'
      );

      let fit = get(image, 'pivot.fit') || 'fit=crop&crop=focalpoint&x=.5&y=.5&z=1';

      const parameters = {
        // ... get(fit.match(/x=(?<fx>[0-1]?\.?[0-9]*)/), 'groups'),
        // ... get(fit.match(/y=(?<fy>[0-1]?\.?[0-9]*)/), 'groups'),
        // ... get(fit.match(/z=(?<fz>[1-9]+\.?[0-9]*)/), 'groups'),
        ...get(fit.match(/w=(?<w>[0-9]+\.?[0-9]*)/), 'groups'),
        ...get(fit.match(/h=(?<h>[0-9]+\.?[0-9]*)/), 'groups')
      };
      let { w, h } = parameters;
      // let { w, h, fx, fy, fz } = parameters
      // if (! fz) fz = 1

      if (w && h) {
        fit = fit.replace(/w=([0-9]+\.?[0-9]*)/, `w=${this.width}`).replace(/h=([0-9]+\.?[0-9]*)/, `h=${this.height}`);
      } else if (!w && !h) {
        fit += `&w=${this.width}&h=${this.height}`;
      }

      return {
        src: `${storageRoute}/images/${image.id}/${image.name}?${fit}`,
        error: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=greyscale`,
        loading: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=blur`,
        width: this.width,
        height: this.height
      };
    }
  },
  mounted() {
    const calculateMaxWidth = () => {
      if (this.$refs.container) {
        const style = getComputedStyle(this.$refs.container);
        this.width = this.$refs.container.clientWidth;
        this.width -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
      }
    };

    window.addEventListener('resize', debounce(calculateMaxWidth, 100));
    calculateMaxWidth();
  }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"
.image
  img
    object-fit: cover
.banner-container
  box-shadow: $box-shadow-1
  background: $skeletonColor
</style>
